import { render, staticRenderFns } from "./CustomerAgreementModal.vue?vue&type=template&id=8848fe70&"
import script from "./CustomerAgreementModal.vue?vue&type=script&lang=js&"
export * from "./CustomerAgreementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports